import React from 'react';
import { ThemeContext } from './ThemeProvider.jsx';
import { apiFetch } from '../api.js';

export default function Topbar({ role, user, sidebarOpen, onToggleSidebar }) {
  const { theme, setTheme } = React.useContext(ThemeContext);
  const [savingTheme, setSavingTheme] = React.useState(false);
  const toggleTheme = async () => {
    if (savingTheme) return;
    const previousTheme = theme;
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(nextTheme);

    if (!role || !user) return;
    const endpoint = role === 'admin' ? `/api/admins/${user.id}` : role === 'student' ? '/api/students/me' : '';
    if (!endpoint) return;

    try {
      setSavingTheme(true);
      await apiFetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify({ dark_mode: nextTheme === 'dark' ? 1 : 0 })
      });
    } catch (err) {
      setTheme(previousTheme);
    } finally {
      setSavingTheme(false);
    }
  };
  const initials = getInitials(user);
  const nextModeLabel = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <header className="topbar">
      <div className="topbar-left">
        {onToggleSidebar ? (
          <button
            className="topbar-hamburger"
            onClick={onToggleSidebar}
            type="button"
            aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={sidebarOpen ? 'true' : 'false'}
          >
            <span className="hamburger-line" />
            <span className="hamburger-line" />
            <span className="hamburger-line" />
          </button>
        ) : null}
        <span className="topbar-title">ECE Portal</span>
      </div>
      <div className="topbar-right">
        <button
          className="btn btn-ghost btn-sm topbar-theme"
          onClick={toggleTheme}
          type="button"
          disabled={savingTheme}
          aria-label={nextModeLabel}
        >
          <span className="theme-icon-wrap">
            {theme === 'dark' ? (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="5" />
                <line x1="12" y1="1" x2="12" y2="3" />
                <line x1="12" y1="21" x2="12" y2="23" />
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                <line x1="1" y1="12" x2="3" y2="12" />
                <line x1="21" y1="12" x2="23" y2="12" />
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            )}
          </span>
        </button>
        <div className="avatar">{initials}</div>
      </div>
    </header>
  );
}

function getInitials(user) {
  if (!user) return '??';
  const first = user.first_name || user.username || '';
  const last = user.last_name || '';
  const firstInitial = first.trim().charAt(0);
  const lastInitial = last.trim().charAt(0);
  const combined = `${firstInitial}${lastInitial}`.trim();
  if (combined) return combined.toUpperCase();
  if (user.email) return user.email.trim().charAt(0).toUpperCase();
  return '??';
}
